import React from 'react';
import { AvatarWrapper, DefaultAvatar, SubAvatar } from './style';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import theme from '../../shared/theme';

const AVATAR_COLOURS_COUNT = 14;

export default class InitialsAvatar extends React.Component {
  getAvatarColour(member) {
    // Create a "hash" by summing the unicode value of each character in the userId.
    let userId = '';
    if (member.id) {
      userId = member.id;
    } else if (member.user) {
      userId = member.user.id;
    }
    const hash = userId.split('').reduce((acc, curr) => {
      return acc + curr.charCodeAt(0);
    }, 0);

    return hash % AVATAR_COLOURS_COUNT;
  }

  renderName() {
    const { member } = this.props;
    if (!member) {
      return null;
    }
    if (member.user) {
      const { user } = member;
      return `${user.firstName ? user.firstName[0] : ''}${
        user.lastName ? user.lastName[0] : ''
      }`;
    }
    return `${member.firstName ? member.firstName[0] : ''}${
      member.lastName ? member.lastName[0] : ''
    }`;
  }
  renderIdentity(member) {
    if (member.isExpert) {
      return <VerifiedUserIcon style={{ color: theme.main.base_color }} />;
    }
    if (member.isChair) {
      return <EventSeatIcon style={{ color: theme.main.base_color }} />;
    }
    return null;
  }
  render() {
    const { size, member, fontSize } = this.props;
    return (
      <AvatarWrapper size={size}>
        <DefaultAvatar
          size={size}
          fontSize={fontSize}
          colorIndex={this.getAvatarColour(member)}
        >
          {this.renderName()}
        </DefaultAvatar>
        <SubAvatar>{this.renderIdentity(member)}</SubAvatar>
      </AvatarWrapper>
    );
  }
}
